import type { BreakdownItem } from '@/types/analytics'
import { getBreakdownItemColor } from '@/utils/chartUtils/breakdownItemColor'
import { cn } from '@/utils/cn'
import { NETWORKS, type Network } from '@vaultsfyi/common/types'
import { formatDecimalToPercentage, formatUSD } from '@vaultsfyi/common/utils'

interface Props {
  items: BreakdownItem[]
  className?: string
}

export function TvlBreakdownLegend({ items, className }: Props) {
  return (
    <ul className={cn('flex flex-1 flex-col gap-1.5', className)}>
      {items.map((item, index) => (
        <li key={item.name} className="flex items-center gap-2 text-sm">
          <span
            className="size-3 min-w-3 rounded-full"
            style={{ backgroundColor: getBreakdownItemColor(item, index) }}
          />
          <span
            className={cn(
              'flex-1 truncate text-body-foreground',
              NETWORKS.includes(item.name as Network) && 'first-letter:uppercase'
            )}
            title={item.displayName}
          >
            {item.displayName}
          </span>
          <div className="flex gap-3">
            <span className="w-12 text-right text-body-foreground tabular-nums">
              {formatDecimalToPercentage(item.percentage)}
            </span>
            <span className="w-16 text-right text-active-foreground tabular-nums">{formatUSD(item.value)}</span>
          </div>
        </li>
      ))}
    </ul>
  )
}
